<template>
  <span>
    <span v-if="$store.state.main.game.enableSuggestions && suggestions.length">
      <br/>
      <card shadow>
        <strong>
          {{ $t('ideas') }}
        </strong>
        <ul>
          <span v-for="suggestion in suggestions" :key="suggestion.id">
            <li>{{ getName(suggestion) }}{{ suggestion.suggestion }}</li>
          </span>
        </ul>
      </card>
    </span>
    <br/>
  </span>
</template>

<script>

export default {
  data: function () {
    return {
    };
  },
  created() {
  },
  computed: {
    suggestions() {
      const currentCase = this.$store.state.main.game.currentCaseNumber;
      if (currentCase === 0) {
        // Begin page
        return this.$store.state.main.suggestions.filter(suggestion => suggestion.case === null);
      } else {
        return this.$store.state.main.suggestions.filter(suggestion => suggestion.case_number === currentCase);
      }
    }
  },
  methods: {
    getName(suggestion) {
      if (suggestion.player) {
        const player = this.$store.getters.getPlayerById(suggestion.player);
        return player.nick_name + ": ";
      }
      return "";
    }
  },
};
</script>

<i18n>
  {
    "en": {
      "ideas": "Ideas and development proposals"
    },
    "fi": {
      "ideas": "Ideat ja kehitysehdotukset"
    },
    "sv": {
      "ideas": "Idés och utvecklingsförslags"
    },
    "de": {
      "ideas": "Idees und Vorschlags"
    },
   "ko": {
      "ideas": "아이디어 및 개발 제안"
    }
  }
  </i18n>
